<span class="bv-radio__dot"></span>
<span class="bv-radio__label">
  <ng-content></ng-content>
</span>
